



































































































































import { Component, Vue } from 'vue-property-decorator';

import TabMenu from '@/components/period/member/searchForm/TabMenu.vue';
import NoticeBox from '@/components/period/member/searchForm/NoticeBox.vue';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import CompRadioButton from '@/components/common/CompRadioButton.vue';
import CompCheckBox from '@/components/common/CompCheckBoxButton.vue';
import moment from 'moment';
import { namespace } from 'vuex-class';
import { Mall, GetMembersJoinConfigResponse, GetStatisticMembersSummaryByPeriodRequest, StatisticProviderType } from 'supporter';
import { getFirstAndEndDay, getToday, addMonth, getStrDate, addDay } from '@/utils/dateUtils';
import { Menu } from '@/types/admin';
import { toI18n } from '@/utils/commonUtils';
import { getYearList, getMonthList } from '@/utils/dateUtils';
import { DateType } from '@/types/memberStatistic';
import { GlobalMall } from '@/types';
const statisticModule = namespace('memberStatistic');
const mallModule = namespace('mall');
const initMemberTypes = ['MALL','SYNC_ID','OPEN_ID'];
const initProviders = 'PAYCO,NAVER,KAKAO,FACEBOOK,LINE,GOOGLE,APPLE,APP_CARD';

@Component({
  components: {
    TabMenu,
    NoticeBox,
    CompRadioButton,
    PeriodDateCalendar,
    CompSelectBox,
    CompCheckBox,
  },
})
export default class SearchForm extends Vue {
  @statisticModule.State('membersJoinConfigResponse')
  private membersJoinConfigResponse!: GetMembersJoinConfigResponse;
  @statisticModule.State('queryOption')
  private queryOption!: { page: number; pageSize: number };
  @mallModule.Getter('malls')
  private readonly _malls!: Mall[];
  @mallModule.Getter('mallsGlobal')
  private readonly malls: GlobalMall[];
  @statisticModule.Mutation('SET_MALL_NAME')
  public setMallName!: (type: string) => void;
  @statisticModule.Mutation('SET_DATE_TYPE')
  public setDateType!: (type: DateType) => void;
  @statisticModule.Mutation('SET_START_YMD')
  public setStartYmd!: (ymd: string) => void;
  @statisticModule.Mutation('SET_END_YMD')
  public setEndYmd!: (ymd: string) => void;
  @statisticModule.Mutation('SET_YEAR')
  public setYear!: (year: string) => void;
  @statisticModule.Mutation('SET_MONTH')
  public setMonth!: (month: string) => void;
  @statisticModule.Mutation('SET_PAGE')
  public setPage!: (page: number) => void;
  @statisticModule.Action('fetchStatisticMembersSummaryByPeriod')
  fetchStatisticMembersSummaryByPeriod: (query) => Promise<void>;
  @statisticModule.Action('getStatisticsMembersByPeriod')
  getStatisticsMembersByPeriod: (query) => Promise<void>;
  @statisticModule.Action('fetchMemberJoinConfig')
  private fetchMemberJoinConfig: (query) => Promise<void>;

  private memberTypes = initMemberTypes;
  private providers = initProviders;

  private get mallList() {
    const list: any = [];
    if (this.malls) {
      this.malls.forEach(mall => {
        if (mall.used) {
          list.push({
            value: mall.mallNo,
            name: mall.mallName
          });
        }
      });
    }

    return list;
  }

  private get mallName(): string {
    return this.mallList.find(mall => mall.value === this.query.params.mallNo)?.name || '';
  }

  private handleOpenId({ target }: { target: HTMLInputElement}) {
    if (!this.memberTypes.includes('OPEN_ID')) {
      target.checked && (this.$refs.openIdTypes as any).setValues(initProviders);
    } else {
      (this.$refs.openIdTypes as any).setValues();
    }
  }

  private openIdTypesCheckboxOptions = {
    name: 'openIdTypes',
    noBrackets: false,
    data: [
      {
        id: 'PAYCO',
        value: 'PAYCO',
        dispaly: 'COMMON_MALLTYPE_PAYCO',
      },
      {
        id: 'NAVER',
        value: 'NAVER',
        dispaly: 'COMMON_MALLTYPE_NAVER',
      },
      {
        id: 'KAKAO',
        value: 'KAKAO',
        dispaly: 'COMMON_MALLTYPE_KAKAO',
      },
      {
        id: 'FACEBOOK',
        value: 'FACEBOOK',
        dispaly: 'COMMON_MALLTYPE_FACEBOOK',
      },
      {
        id: 'LINE',
        value: 'LINE',
        dispaly: 'COMMON_MALLTYPE_LINE',
      },
      {
        id: 'GOOGLE',
        value: 'GOOGLE',
        dispaly: 'COMMON_MALLTYPE_GOOGLE',
      },
      {
        id: 'APPLE',
        value: 'APPLE',
        dispaly: 'COMMON_MALLTYPE_APPLE',
      },
      {
        id: 'APP_CARD',
        value: 'APP_CARD',
        dispaly: 'COMMON_MALLTYPE_APP_CARD',
      },
    ],
  };

  // 탭 메뉴
  private tabMenus: Menu[] = [
    {
      menuNo: 0,
      menuUrl: '/statistic/member/period',
      menuNameLabel: this.toI18n('STATISTIC_MEMBER_PERIOD_INFO'),
    },
  ];

  // 회원 성별
  private genderTypesCheckboxOptions = {
    name: 'genderTypes',
    hasAll: true,
    noBrackets: true,
    data: [
      {
        id: 'ALL',
        value: 'ALL',
        dispaly: 'STATISTIC_MEMBER_ALL',
      },
      {
        id: 'MALE',
        value: 'MALE',
        dispaly: 'STATISTIC_MEMBER_MALE',
      },
      {
        id: 'FEMALE',
        value: 'FEMALE',
        dispaly: 'STATISTIC_MEMBER_FEMALE',
      },
      {
        id: 'NON_BINARY',
        value: 'NON_BINARY',
        dispaly: 'STATISTIC_MEMBER_UNCLASSIFIED',
      },
    ],
  };

  // 플랫폼 구분
  private joinRouteTypesCheckboxOptions = {
    name: 'joinRouteTypes',
    hasAll: true,
    noBrackets: true,
    data: [
      {
        id: 'ALL',
        value: 'ALL',
        dispaly: 'STATISTIC_MEMBER_SELECT_ALL',
      },
      {
        id: 'PC_WEB',
        value: 'PC_WEB',
        dispaly: 'STATISTIC_MEMBER_PLATFORM_TYPE_PC',
      },
      {
        id: 'MOBILE_WEB',
        value: 'MOBILE_WEB',
        dispaly: 'STATISTIC_MEMBER_PLATFORM_TYPE_MOBILE_WEB',
      },
      {
        id: 'MOBILE_APP',
        value: 'MOBILE_APP',
        dispaly: 'STATISTIC_MEMBER_PLATFORM_TYPE_MOBILE_APP',
      },
    ],
  };

  // 조회기간
  private dateType: DateType = 'PERIOD';
  private dateTypes = [
    {
      dateTypeValue: 'PERIOD',
      dateTypeName: 'STATISTIC_MEMBER_BY_PERIOD',
    },
    {
      dateTypeValue: 'MONTH',
      dateTypeName: 'STATISTIC_MEMBER_MONTHLY',
    },
  ];

  private year: number = new Date().getFullYear();
  private beginYear: number = new Date().getFullYear() - 5 >= 2017 ? new Date().getFullYear() - 5 : 2017;

  private get years() {
    return getYearList(this.beginYear, this.toI18n('COMMON_YEAR'));
  }

  private month: number = new Date().getMonth() + 1;

  private get months() {
    return getMonthList(this.toI18n('COMMON_MONTH'));
  }

  private periodOption = {
    havePeriodBtn: true,
    dateType: 'Ymd',
    period: 'ytd',
    periodTypes: ['td', 'ytd', '1w', '1m'],
  };

  // 조회 쿼리
  private query: GetStatisticMembersSummaryByPeriodRequest = {
    params: {
      mallNo: '',
      startDate: addDay(new Date(), -1),
      endDate: addDay(new Date(), -1),
      genderTypes: 'ALL',
      joinRouteTypes: 'ALL',
    },
  };

  private created() {
    this.query.params.mallNo = String(this._malls[0].mallNo);
  }

  private mounted() {
    (this.$refs.issuableGenderTypes as any).setValues('ALL', 'MALE', 'FEMALE', 'NON_BINARY');
    (this.$refs.issuableJoinRoute as any).setValues('ALL', 'PC_WEB', 'MOBILE_WEB', 'MOBILE_APP');
  }

  // 검색
  public async onSearch(page?: number) {
    const providerParam = this.providers === 'ALL' ? '' : this.providers;

    this.query.params.providers = providerParam as StatisticProviderType;
    this.query.params.memberTypes = this.memberTypes.join(',');

    if (this.query.params.memberTypes.indexOf('OPEN_ID') < 0) {
      delete this.query.params.providers
    }

    if (!this.validate()) return;
    if (page) this.setPage(page);
    if (this.dateType === 'MONTH') this.monthToPeriod();

    this.emitQuery();

    if (this.query) {
      try {
        await this.fetchMemberJoinConfig({
          params: { mallNo: this.query.params.mallNo },
        });

        const statisticMembersSummaryByPeriodQuery = this.stringParamsReflect(JSON.parse(JSON.stringify(this.query)));
        await this.fetchStatisticMembersSummaryByPeriod(this.paramsFilter(statisticMembersSummaryByPeriodQuery));
        await this.getStatisticsMembersByPeriod(
          this.paramsFilter({
            params: {
              ...statisticMembersSummaryByPeriodQuery.params,
              ...this.queryOption,
            },
          }),
        );
      } catch (error) {
      }
    }
  }

  private validate() {
    const { memberTypes, providers, genderTypes, joinRouteTypes, startDate, endDate } = this.query.params;

    if (!memberTypes.length) {
      alert(this.toI18n('STATISTIC_MEMBER_VERIFY_MESSAGE_MEMBER_TYPE'));

      return false;
    }

    if (memberTypes.indexOf('OPEN_ID') > 0 && this.providers !== 'ALL' && (!providers.length)) { 
      alert(this.toI18n('STATISTIC_MEMBER_VERIFY_MESSAGE_OPEN_ID_MEMBER_TYPE'));

      return false;
    }

    if (!genderTypes) {
      alert(this.toI18n('STATISTIC_MEMBER_VERIFY_MESSAGE_GENDER'));

      return false;
    }
    
    if (!joinRouteTypes) {
      alert(this.toI18n('STATISTIC_MEMBER_VERIFY_MESSAGE_PLATFORM'));

      return false;
    }

    const startDateConvert = moment(startDate).unix() / 60 / 60 / 24;
    const endDateConvert = moment(endDate).unix() / 60 / 60 / 24;

    if (endDateConvert - startDateConvert > 92) {
      alert(this.toI18n('STATISTIC_MEMBER_VERIFY_MESSAGE_DATE_MAX_RANGE'));

      return false;
    }

    return true;
  }

  // 콘텐츠내에 표기될 일부 쿼리 정보를 store로 전달
  private emitQuery() {
    if (this.mallName) this.setMallName(this.mallName);
    this.setDateType(this.dateType);
    this.setStartYmd(this.query.params.startDate);
    this.setEndYmd(this.query.params.endDate);
    this.setYear(String(this.year));
    this.setMonth(String(this.month));
  }

  private stringParamsReflect(obj: any): any {
    if (obj.params.memberType) obj.params.memberType = this.allToEmptyValue(obj.params.memberType);
    if (obj.params.genderTypes) obj.params.genderTypes = this.allToEmptyValue(obj.params.genderTypes);
    if (obj.params.joinRouteTypes) obj.params.joinRouteTypes = this.allToEmptyValue(obj.params.joinRouteTypes);
    return obj;
  }

  private allToEmptyValue(str: string): string {
    return str === 'ALL' ? '' : str;
  }

  private paramsFilter(queryData: any) {
    const temp: { params: { [unit: string]: string } } = {
      params: {},
    };
    for (const param in queryData.params) {
      if (queryData.params[param] !== '') {
        temp.params[param] = queryData.params[param];
      }
    }
    return temp;
  }

  private monthToPeriod(): void {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const isCurrentMonth = currentMonth === this.month;

    const { startYmd, endYmd } = getFirstAndEndDay(this.year, this.month);
    this.query.params.startDate = startYmd;

    this.query.params.endDate = isCurrentMonth ? getStrDate(currentDate) : endYmd;
  }

  private reset(): void {
    this.searchFormReset();
  }

  private searchFormReset(): void {
    this.query.params.mallNo = String(this._malls[0].mallNo);
    this.query.params.genderTypes = 'ALL';
    (this.$refs.issuableGenderTypes as any).setValues('ALL', 'MALE', 'FEMALE', 'NON_BINARY');
    this.query.params.joinRouteTypes = 'ALL';
    (this.$refs.issuableJoinRoute as any).setValues('ALL', 'PC_WEB', 'MOBILE_WEB', 'MOBILE_APP');
    this.memberTypes = initMemberTypes;
    (this.$refs.openIdTypes as any).setValues(initProviders)
    this.dateType = 'PERIOD';
    this.query.params.startDate = addMonth(new Date(), -1);
    this.query.params.endDate = getToday();
    (this.$refs.combinedPeriod as any).clickPeriod('1m');
    this.year = new Date().getFullYear();
    this.month = new Date().getMonth() + 1;
  }

  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t(needToI18nStr));
  }
}
